import { render } from "./detail.vue?vue&type=template&id=df2455b0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=df2455b0&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2455b0"],['__file',"src/views/settings/printer/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df2455b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df2455b0', __exports__)) {
    console.log('reload')
    api.reload('df2455b0', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=df2455b0&scoped=true", () => {
    console.log('re-render')
    api.rerender('df2455b0', render)
  })

}


export default __exports__